import { Component, OnInit } from "@angular/core";
import { appendRowNodeIdToInputAriaLabel } from "@coso/grid";
import { ColDef, GridOptions, ICellRendererParams, SelectionChangedEvent } from "ag-grid-community";
import { ISharePointLoginInfo, IUserPair, MappingMode, UserMappingOperation } from "../../../../../models/auto-generated";
import { UserMappingDto } from "../../../../../models/user-mapping-dto";
import { SharePointUser } from "../../models/sharepoint-user";
import { SharePointUserType } from "../../models/sharepoint-user-type";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone:false,
  templateUrl: "./custom-user-mapping.component.html"
})
export class CustomUserMappingComponent implements OnInit {
  gridOptions: GridOptions;
  columnDefs: ColDef[];
  errorMessage: string;
  mappingMode: MappingMode;
  userMappings: UserMappingDto[];
  userMappingToEdit: UserMappingDto;
  userPairsToEdit: IUserPair[] = [];
  users: SharePointUser[];
  saveCallback: (newPairs: IUserPair[]) => void;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.gridOptions = {
      domLayout: "normal",
      rowHeight: 40,
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      onSelectionChanged: this.onSelectionChanged.bind(this),
      onFirstDataRendered: (e) => {
        e.api.setGridAriaProperty("label", "List of SharePoint users");
        e.api.forEachNode((node) => {
          if (this.isAutoMapping(node.data) || this.isCustomMapping(node.data)) {
            node.setSelected(true);
            const elements = document.querySelectorAll(`.modal-body [row-id='${node.id}'] .ag-checkbox-input-wrapper`);
            for (let i = 0; i < elements.length; i++) elements[i].classList.add("ag-checked");
          }
          appendRowNodeIdToInputAriaLabel(node);
        });
      },
      isRowSelectable: (node) => !this.isAutoMapping(node.data),
      getRowId: (params) => `${params.data.type}${params.data.id}`
    };

    this.columnDefs = [
      {
        headerName: "Type",
        field: "type",
        checkboxSelection: true,
        sortable: false,
        cellRenderer: (params: ICellRendererParams) => {
          switch (params.value) {
            case SharePointUserType.User:
              return "User";
            case SharePointUserType.SharePointGroup:
              return "SharePoint Group";
            case SharePointUserType.DirectoryGroup:
              return "Directory Group";
          }
        }
      },
      { headerName: "Title", field: "name" },
      { headerName: "Login", field: "loginName" }
    ];
  }

  save() {
    this.saveCallback(this.userPairsToEdit);
  }

  private onSelectionChanged(event: SelectionChangedEvent) {
    event.api.forEachNode(appendRowNodeIdToInputAriaLabel);
    const rows = event.api.getSelectedRows();
    this.userPairsToEdit = Object.assign(
      [],
      rows.map((r) => {
        return {
          crM_ID: this.userMappingToEdit.crmId,
          email: this.userMappingToEdit.email,
          name: this.userMappingToEdit.name,
          operation: UserMappingOperation.Add,
          sharePoint_ID: r.id
        };
      })
    );
  }

  private isAutoMapping(user: SharePointUser): boolean {
    if (this.userMappingToEdit.loginInfo) {
      return (
        this.mappingMode === MappingMode.APPEND &&
        this.userMappings.find((m) => {
          const loginInfo = m.loginInfo as ISharePointLoginInfo;
          return m.crmId === this.userMappingToEdit.crmId && loginInfo && loginInfo.id === user.id && !m.loginInfo.isCustomMapping;
        }) &&
        !this.isCustomMapping(user)
      );
    } else {
      return false;
    }
  }

  private isCustomMapping(user: SharePointUser): boolean {
    return this.userPairsToEdit.findIndex((u) => this.userMappingToEdit.crmId === u.crM_ID && user.id === u.sharePoint_ID) > -1;
  }
}
